import { convertScifinderPDFFiles } from './convert-scifinder-pdf-files'
import { getPresignedS3UploadLink } from './get-presigned-s3-upload-link'
import { uploadFileToS3 } from './upload-file-to-s3'
import { uploadScifinderAltaExcelFiles, uploadScifinderExcelFiles } from './upload-scifinder-excel-files'
import { getComplianceBaseDownloadLink } from './get-compliance-base-download-url'
import { getPresignedS3UploadAltaLink } from './get-presigned-s3-upload-alta-link'

export const scifinderApi = {
  convertScifinderPDFFiles,
  getPresignedS3UploadLink,
  getPresignedS3UploadAltaLink,
  uploadFileToS3,
  uploadScifinderExcelFiles,
  uploadScifinderAltaExcelFiles,
  getComplianceBaseDownloadLink,
}
